import styled from "styled-components";
import CheckboxOptions from "../../forms/CheckboxOptions";

const CheckboxOptionsStyled = styled(CheckboxOptions)`
  margin-top: 10px;
  margin-bottom: 20px;
  display: block;
`;

export default CheckboxOptionsStyled;
